import { cn } from "@/lib/utils";

/** A section heading: Announcements, Positions, Who is working. */
export function SectionHeader({
  icon: Icon,
  children,
  className,
}: {
  icon?: React.ElementType;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <h2
      // font-sans is load-bearing: index.css sets every h1-h3 in Bodoni, whose
      // hairlines drop out at 15px uppercase on a dark ground.
      className={cn(
        "flex items-center gap-2.5 font-sans text-[15px] font-bold uppercase tracking-eyebrow text-foreground",
        className,
      )}
    >
      {Icon && <Icon className="h-4 w-4 text-primary" />}
      {children}
    </h2>
  );
}

export function Eyebrow({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <p
      className={cn(
        "text-[11px] font-semibold uppercase tracking-eyebrow text-muted-foreground",
        className,
      )}
    >
      {children}
    </p>
  );
}

/**
 * Inline figures: counts, list money, anything at body size.
 *
 * Sans, not the display serif: Bodoni's hairlines go mushy at these sizes on a
 * dark ground, which is what made "8/12" hard to read.
 */
export function Figure({
  children,
  className,
  ...rest
}: React.HTMLAttributes<HTMLSpanElement> & {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn("font-sans font-medium tabular-nums", className)}
      {...rest}
    >
      {children}
    </span>
  );
}
